import { useTranslation } from "@localization/useTranslation";
import GroupEntitySelector from "@common/components/GroupEntitySelector";
import { ActivityGroupCompaniesSectionProps, useActivityGroupCompaniesSection } from "./ActivityGroupCompaniesSection.hooks";

function ActivityGroupCompaniesSection(props: ActivityGroupCompaniesSectionProps) {
    const { translateString } = useTranslation();
    const { onGroupCompaniesChange, onGroupCompanyResponsibleChange, showResponsibleError } = useActivityGroupCompaniesSection(props);

    // The selector renders its own header and box, and nothing at all for a customer with a single group company.
    if (props.model.isProcessingActivityValidation) {
        return (
            <GroupEntitySelector
                header={translateString("groupCompanies")}
                headerStyle={"medium"}
                switchLabel={translateString("globalAnnualWheelActivity")}
                explanation={translateString("globalAnnualWheelActivityTooltipProcessingActivityValidation")}
                selectedUserGroupCompanies={props.model.groupCompanies}
                onGroupCompaniesChange={onGroupCompaniesChange}
                enableResponsibleColumn={false}
                disabled={props.readOnly}
            />
        );
    }

    return (
        <GroupEntitySelector
            header={translateString("groupCompanies")}
            headerStyle={"medium"}
            switchLabel={translateString("globalAnnualWheelActivity")}
            appliesToAllDescription={translateString("obligationGroupCompaniesOneSharedTask")}
            appliesToSelectedDescription={translateString("obligationGroupCompaniesOwnTaskEach")}
            selectedUserGroupCompanies={props.model.groupCompanies}
            assignees={props.model.assignees}
            responsible={props.model.responsible}
            onGroupCompaniesChange={onGroupCompaniesChange}
            onGroupCompanyResponsibleChange={onGroupCompanyResponsibleChange}
            showError={showResponsibleError}
            errorText={translateString("annualWheelDataTaskResponsibleError")}
            enableResponsibleColumn
            disabled={props.readOnly}
        />
    );
}

export default ActivityGroupCompaniesSection;
